module.exports = __webpack_public_path__ + "assets/img/car04.8027148d.png";